import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "earthFilled"
const EarthFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12 1.5C13.911 1.5 15.706 2.012 17.25 2.906 20.388 4.72 22.5 8.113 22.5 12 22.5 13.126 22.322 14.212 21.993 15.23 20.631 19.449 16.673 22.5 12 22.5 11.167 22.5 10.356 22.403 9.578 22.219 4.947 21.125 1.5 16.966 1.5 12 1.5 10.874 1.678 9.788 2.007 8.77 3.369 4.551 7.327 1.5 12 1.5M3.286 9.75C3.1 10.469 3 11.222 3 12 3 15.918 5.505 19.25 9 20.486V17.689L12 14.69V13.06L8.69 9.75zM12 5.804V7.94L14.56 10.5H16.136L19.638 15.403 20.626 14.569C20.868 13.756 21 12.894 21 12 21 8.74 19.266 5.884 16.668 4.304H13.444z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default EarthFilledIcon
